import { render } from "./RegistrationCommunicationData.vue?vue&type=template&id=0549700b&scoped=true&ts=true"
import script from "./RegistrationCommunicationData.vue?vue&type=script&lang=ts"
export * from "./RegistrationCommunicationData.vue?vue&type=script&lang=ts"

import "./RegistrationCommunicationData.vue?vue&type=style&index=0&id=0549700b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0549700b"]])

export default __exports__